import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "./useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import ExcelRecPopup from "./ExportRecon";
import UploadContract from "./UploadContract";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import SynchronizePaymentsModel from "./SynchronizePaymentsModel";


const Reconsilation = (props) => {
  const [campaigns, handleCampaignList] = useState([]);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [packagetype, handlePackagetype] = useState(undefined);
  const [razorpay, handleRazorpay] = useState(undefined);
  const searchRazorpay = useRef(undefined);
  const searchCampaign = useRef(undefined)

  const [email, handleEmail] = useState(undefined);
  const [searchName, handleSearchName] = useState(undefined);
  //vj
  // const [searchStation, handleSearchStation] = useState(undefined);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const campaignName = useRef(undefined);
  const userEmail = useRef(undefined);

  const { isRecordOfflineModalShowing, recordOfflineModalToggle } = useModel();
  const [showRecordOfflineModal, handleShowRecordOfflineModal] = useState(false);
  

  const toggleRecordOfflineModal = () => {
    recordOfflineModalToggle();
    window.location.reload();
  };

  const closeRecordOfflineModal = () => {
    recordOfflineModalToggle();
  };
  
  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  }, []);

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    if (!reset) {
        paramsConstrct = {
          skip,
          campaignName: campaignName.current.value,
          userEmail: userEmail.current.value,
          campaignId: searchCampaign.current.value,
          paymentId: searchRazorpay.current.value,
          startDate: startDate,
          endDate: endDate,
          status: packagetype != "Production Sale" ? packagetype : undefined,
        };
    }

    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.getReconDetails, {
        params: paramsConstrct,
      });
      let result = data.data.data.data;
      if (result) {
        handleCampaignList(result);
        handleSearchName(name);
        handleRazorpay(razorpay);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showHideExcelPopup = () => {
    setShowHideExcelPopup(!showExcelPopup);
  };
  const callSearch = () => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  };

  const clearSearch = () => {
    window.location.reload(true);
  };


  //Return the table for campaign
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
              Payment Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                Reconciliation List
                </span>
              </div>
              <div className="print_btn">
                <button onClick={showHideExcelPopup}> Download Excel </button>{" "}
                <button onClick={recordOfflineModalToggle}> Synchronize Payments </button>{" "}
              </div>{" "}
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="startDate">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Start Date"
                          maxDate={endDate}
                          isClearable
                        />
                      </div>
                    </td>
                    <td>
                      <div className="endDate">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          minDate={startDate}
                          placeholderText=" End date"
                          isClearable
                        />
                      </div>
                    </td>
                    <td>
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon"
                          onChange={(event) =>
                            handlePackagetype(event.target.value)
                          }
                        >
                          <option value=""> Choose Status </option>
                          <option value="Captured">Captured</option>
                          <option value="Authorized">Authorized</option>
                          <option value="Settled"> Settled </option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div className="print_btn">
                        
                        {/***  <button type="button" onClick={clearSearch}>Clear</button>*/}
                        <button type="reset" onClick={clearSearch}>
                          Clear
                        </button>
                      </div>
                    </td>
                    <td> </td>
                  </tr>
                  <tr>
                  <td>
                      <div
                        className={
                          !razorpay && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={searchRazorpay}
                          placeholder="Razor Pay ID"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                     <td>
                      <div
                        className={
                          !searchName && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        <input
                          type="text"
                          ref={campaignName}
                          placeholder="Enter campaign name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          !email && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={userEmail}
                          placeholder="Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          !razorpay && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={searchCampaign}
                          placeholder="Campaign ID"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    
                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th> Payment Id </th> <th> Campaign Name </th>
                    <th> Campaign ID </th> <th> Payment Date </th>
                    <th> Payment Status </th> <th> Transaction Amount </th>
                    <th> Settlement date </th> <th> Settlement ID </th>
                    <th> Settlement Amount </th> <th> Razorpay Fee </th>
                    <th> Gst on RP Fee </th> <th> Total Fee </th>
                    <th> UTR No </th> <th> Customer Email </th>
                    <th> Customer Number </th>
                    <th>Customer Name</th>
                    <th>Company Name</th>
                    <th>GST No</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td> {c.paymentId} </td><td>{c.campaignName}</td>
                      <td>{c.campaignId}</td>
                      <td>
                        {moment(parseInt(c.paymentDate) * 1000).format("DD/MM/YYYY")}
                      </td>
                      <td> {c.status} </td> <td> {c.amount} </td>
                      <td>{c.settlementDetails && c.settlementDetails.settled_at && c.settlementDetails.settled_at && moment(c.settlementDetails.settled_at * 1000).format('DD/MM/YYYY')} </td>
                      <td>{c.settlementDetails && c.settlementDetails.settlement_id} </td>
                      <td>{c.settlementDetails && c.settlementDetails.amountReceived} </td>
                      <td>{c.settlementDetails && c.settlementDetails.razorPayfee} </td>
                      <td className="txt-cntr">{c.settlementDetails && c.settlementDetails.razorpayTax}</td>
                  <td> {c.settlementDetails && c.settlementDetails.totalfee} </td> <td> {c.settlementDetails && c.settlementDetails.settlement_utr}</td> <td> {c.customerDetails && c.customerDetails.email} </td>
                      <td> {c.customerDetails && c.customerDetails.contact} </td>
                      <td>{c.customerDetails && c.customerDetails.name}</td>
                      <td>{c.customerDetails && c.customerDetails.company}</td>
                      <td>{c.customerDetails && c.customerDetails.gstno}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationTable" />
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}
            </div>
            {campaigns.length === 0 ? <NoData /> : null}
          </section>
        </div>
      </div>
      {showExcelPopup && <ExcelRecPopup hideExcelPopup={showHideExcelPopup} />}

      
      {/* <RecordOfflinePayment 
        isShown={isRecordOfflineModalShowing}
        hide={toggleRecordOfflineModal}
        close={closeRecordOfflineModal}
      /> */}

      <SynchronizePaymentsModel 
        isShown={isRecordOfflineModalShowing}
        hide={toggleRecordOfflineModal}
        close={closeRecordOfflineModal}
      />
      
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(Reconsilation);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/reconcilation.js